import Vue from 'vue'
import axios from 'axios'
import store from '@/store'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
})

service.interceptors.request.use(
  config => {
    const token = store.getters['user/token']
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.status !== 200) {
      showError(res.message || '请求失败')
      if (res.status === 401) {
        store.dispatch('user/logout')
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    const status = error.response?.status
    const messages = {
      400: '请求参数错误',
      401: '未授权，请重新登录',
      403: '拒绝访问',
      404: '请求资源不存在',
      408: '请求超时',
      500: '服务器内部错误',
      502: '网关错误',
      503: '服务不可用',
      504: '网关超时'
    }
    const msg = messages[status] || `连接出错(${status || '未知'})`
    showError(msg)

    if (status === 401) {
      store.dispatch('user/logout')
    }
    return Promise.reject(error)
  }
)

function showError(msg) {
  if (Vue.prototype.$message) {
    Vue.prototype.$message.error(msg)
  } else {
    console.error('[Request Error]', msg)
  }
}

export function get(url, params) {
  return service.get(url, { params })
}

export function post(url, data) {
  return service.post(url, data)
}

export function put(url, data) {
  return service.put(url, data)
}

export function del(url, params) {
  return service.delete(url, { params })
}

export function upload(url, file, fieldName = 'file', data = {}) {
  const formData = new FormData()
  formData.append(fieldName, file)
  Object.keys(data).forEach(key => formData.append(key, data[key]))
  return service.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function download(url, params, filename) {
  return service.get(url, {
    params,
    responseType: 'blob'
  }).then(res => {
    const blob = new Blob([res])
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = filename || 'download'
    link.click()
    URL.revokeObjectURL(link.href)
  })
}

export default service
